import React, {ChangeEvent} from 'react';
import Form from 'react-bootstrap/Form';
import {useFormikContext} from "formik";
import {Col, Row} from "react-bootstrap";
import {EventReviewCriterium} from "../../types/types";
import {CallForPapersReviewFormFields} from "../CallForPapersReviewForm";
import {useIntl} from "react-intl";

interface ReviewRadioGroupControlProps {
    criterium: EventReviewCriterium;
}

/**
 * Komponente, welche für ein Kriterium Radiobuttons rendert
 */
const ReviewRadioGroupControl = ({criterium}: ReviewRadioGroupControlProps) => {
    const {values, setFieldValue} = useFormikContext<CallForPapersReviewFormFields>();
    const intl = useIntl();

    const options = [
        {label: "1", value: 1},
        {label: "2", value: 2},
        {label: "3", value: 3},
        {label: "4", value: 4},
        {label: "5", value: 5},
        {label: "6", value: 6},
        {label: intl.formatMessage({id: "submission.review.scoring.no_decision"}), value: 0}
    ];

    /**
     * Ermittelt die Kriteriumsbewertung anhand des übergebenen Kriteriums
     */
    const findCriteriumScore = () => {
        return values?.review?.criteriaScores?.find(score => score?.criteriumId === criterium.id);
    }

    /**
     * Prüft ob der übergebene Wert durch das onChange-event in den formik state existiert und dementsprechend
     * ob der radiobutton checked oder unchecked ist
     *
     * @param value
     * @return boolean
     */
    const isChecked = (value: any) => {
        const score = findCriteriumScore()?.score;
        if (!score && (value === undefined || value === null)) {
            return true;
        }
        return score === value;
    }

    /**
     * @param event
     */
    const onChange = (event: ChangeEvent<HTMLInputElement>) => {
        const checkedScore = event.target.value;
        const value = [
            // @ts-ignore FIXME Object is possibly undefined
            ...values?.review.criteriaScores.filter(score => score.criteriumId !== criterium.id),
            {criteriumId: criterium.id, score: checkedScore ? parseInt(checkedScore) : undefined}
        ];

        setFieldValue('review.criteriaScores', value)
    }

    return (
        <Form.Group >
            <hr/>
            <Row>
                <Col sm={4}>
                    <Form.Label><b>{criterium.name}</b></Form.Label>
                </Col>
                {options.map(({label, value}, index) => (
                    <Col sm={1} key={index}>
                        <Form.Check type="radio"
                                    id={`${criterium.id}-${index}`}
                                    label={label}
                                    value={value}
                                    onChange={(e) => onChange(e)}
                                    checked={isChecked(value)}
                        />
                    </Col>
                ))}
            </Row>
        </Form.Group>
    );
}

export default ReviewRadioGroupControl;
